module.exports = __webpack_public_path__ + "static/img/19c.4b3469b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/19c.jpg
// module id = WZVB
// module chunks = 0